import React, { useState } from 'react';
import entityMktSettingsService from '../../services/partnerMktSettingsService';
import './CredentialTest.css';

// Reusable "test connection" control for a marketplace credential. Runs the
// generic marketplace-aware test endpoint (POST /partnermktsettings/test-credentials)
// with the provided settings and renders a pass/fail result. onResult(result) fires
// with { success, message } after each run so the caller can gate on success.
// Two modes:
//   settings      — values not yet saved (the add form), tested as submitted
//   credentialId  — an already-saved credential, tested by id so the secret never reaches the browser;
//                   `overrides` are merged over its stored settings server-side
export default function CredentialTest({ marketplaceId, settings, credentialId, overrides, disabled = false, onResult, label = 'Test connection' }) {
    const [testing, setTesting] = useState(false);
    const [result, setResult]   = useState(null);

    const runTest = async () => {
        setTesting(true);
        setResult(null);
        try {
            const res  = credentialId
                ? await entityMktSettingsService.testSavedCredential(credentialId, overrides)
                : await entityMktSettingsService.testCredentials(marketplaceId, settings);
            const data = res.data || res;
            setResult(data);
            onResult && onResult(data);
        } catch (err) {
            const data = { success: false, message: err.response?.data?.message || 'Test failed' };
            setResult(data);
            onResult && onResult(data);
        } finally {
            setTesting(false);
        }
    };

    return (
        <div className="cred-test">
            <button type="button" className="cred-test-btn" onClick={runTest} disabled={testing || disabled}>
                {testing ? 'Testing…' : label}
            </button>
            {result && (
                <div className={`cred-test-result ${result.success ? 'ok' : 'err'}`}>
                    {result.success ? '✓ ' : '✗ '}{result.message}
                </div>
            )}
            {result?.data?.raw && (
                <pre className="cred-test-raw">{result.data.raw}</pre>
            )}
        </div>
    );
}
